import React from 'react'
import { compose } from 'redux'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withLocalize } from 'react-localize-redux'
import { articles } from 'redux/modules'
import Loader from './Loader'

const ArticleLoader = ({
  children,
  articleId,
  fetchArticle,
  activeLanguage: { code: locale },
  ...restProps
}) => (
  <Loader
    fetchMethod={() => fetchArticle(articleId, { locale })}
    triggers={[locale]}
    {...restProps}
  >
    {children}
  </Loader>
)

ArticleLoader.propTypes = {
  children: PropTypes.node.isRequired,
  articleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  fetchArticle: PropTypes.func.isRequired,
  activeLanguage: PropTypes.shape({
    code: PropTypes.string.isRequired,
  }).isRequired,
}

export default compose(
  connect(null, { fetchArticle: articles.fetchArticle }),
  withLocalize
)(ArticleLoader)
